import { initNav } from './headerNav'
import { watchScrollVisible } from './scrollVisible'
import './scrollSmooth'
import './homeSlide'

initNav()
watchScrollVisible()
